var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUpgradeHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icUpgradeHeader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final-Home-with-submenu",
    transform: "translate(-1421.000000, -196.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1079.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "translate(16.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upgrade",
    transform: "translate(230.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(68.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Membership",
    transform: "translate(28.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9543666,3.72990354 C28.8630999,1.72508039 27.2659323,0.0932475884 25.3036979,0 L24.5735641,0 C24.2084972,0 23.8434304,0.0932475884 23.4783635,0.186495177 L4.03855232,0.186495177 C2.16758458,0.186495177 0.570416994,1.77170418 0.570416994,3.72990354 L0.570416994,4.47588424 C0.570416994,6.4340836 2.12195122,8.0192926 3.99291896,8.0192926 L3.99291896,8.0192926 L14.9905586,8.0192926 L1.02675059,22.3794212 C-0.342250197,23.778135 -0.342250197,25.9694534 1.02675059,27.3681672 L1.52871755,27.8810289 C2.85208497,29.2797428 5.04248623,29.2797428 6.41148702,27.8810289 L6.41148702,27.8810289 L21.1510622,12.8215434 L21.1510622,25.4565916 C21.1510622,27.414791 22.7025964,29 24.6191975,29 L25.3493312,29 C27.2659323,29 28.8174666,27.414791 28.8174666,25.4565916 L28.8174666,5.59485531 C28.9543666,5.22186495 29,4.8488746 29,4.47588424 L28.9543666,3.72990354 Z",
    id: "icUpgradeHeader"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpgradeHeader);
export default __webpack_public_path__ + "static/media/icUpgradeHeader.1eacf77e3f31e3f3c004224442c5b4ba.svg";
export { ForwardRef as ReactComponent };